import { ServiceDefinition } from '@pershing/pershing-core';
// Singleton class
export class EdeliveryServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;
    // doi-retrieve-svc-qat.test.bnymellon.net/bpsretrieve/documents
    uri: string = 'edc/edelivery';
    version: string = 'v1'; // v0.0.2-SNAPSHOT
    family: string = 'edc'; // 'edc';
    appName: string = 'edelivery-service'; // 'docretrieve-service';
    serviceName: string = 'service'; // 'service';
    static getInstance(): ServiceDefinition {
        if (!EdeliveryServiceDefinition.instance) {
            EdeliveryServiceDefinition.instance = new EdeliveryServiceDefinition();
        }
        return EdeliveryServiceDefinition.instance;
    }
    private constructor() {
    }
}
